import { TextProps } from '@chakra-ui/react';
import { Text } from 'components/UI';

const FieldDescription = (props: TextProps) => <Text as="small" w="full" {...props} />;

export default FieldDescription;
